import * as React from 'react';
import type { SVGProps } from 'react';

const ExpandOrgChartPlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <circle cx="9.632" cy="10.1" r="9.505" className="fill-current" />
    <path stroke="#fff" d="M4.584 9.996h10.291M9.549 4.954v10.292" />
  </svg>
);
export default ExpandOrgChartPlusIcon;
